import DashboardLayout from "src/layouts/DashboardLayout";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "src/context";
import { useEffect, useState } from "react";
import { dealerStorage } from "src/utils";
import { Footer } from "./LoginPage/Footer";
import { SubmitSuccess } from "./LoginPage/SubmitSuccess";

export default () => {
  const { dealerName } = useParams();
  const navigate = useNavigate();
  const authObject = useAuth();
  const [userEmail, setUserEmail] = useState("");

  useEffect(() => {
    const value = dealerStorage.getItem("email-for-sign-in");
    if (!value) {
      navigate(`/${dealerName}`);
    }
    setUserEmail(value || "");
  }, []);

  const createMagicLink = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    authObject
      .createMagicLink(userEmail, dealerName ?? "")
      .then(() => {
        dealerStorage.setItem("email-for-sign-in", userEmail);
        navigate(`/${dealerName}/login/email-sent`);
      })
      .catch((error) => {
        console.log("Magic Link ERROR :: ", error);
      });
  };

  return (
    <DashboardLayout
      pageTitle="Email Sent Confirmation"
      backHandler={() => navigate(`/${dealerName}`)}
    >
      <div className="box-border fixed top-1/2 left-1/2 flex w-full max-w-[423px] grow flex-col items-center gap-0 px-5 text-center -translate-x-1/2 -translate-y-1/2">
        <div
          className="mt-12 mb-5 text-center text-[28px] font-medium"
          data-replay-safe
        >
          Check your inbox
        </div>
        <div>
          <div className="mb-7 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-[3px] text-center text-sm font-light text-[#4a5466]">
            A magic link has been sent to{" "}
            <div className="inline rounded-lg bg-[#e5ebfd] px-1.5 py-0.5 text-[#1453f5]">
              {userEmail}
            </div>
          </div>
        </div>
        <SubmitSuccess resendMagicLink={createMagicLink} />
      </div>
      <Footer />
    </DashboardLayout>
  );
};
